
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#575f68","d":"M14.982 7A7.498 7.498 0 008 .017V0H7v.017A7.499 7.499 0 00.017 7H0v1h.017A7.498 7.498 0 007 14.982V15h1v-.018A7.497 7.497 0 0014.982 8H15V7h-.018zM4.695 1.635C4.212 2.277 3.811 3.082 3.519 4H2.021a6.534 6.534 0 012.674-2.365zM1.498 5h1.758a11.876 11.876 0 00-.246 2H1.019a6.444 6.444 0 01.479-2zm-.479 3H3.01c.027.697.112 1.368.246 2H1.498a6.444 6.444 0 01-.479-2zm1.002 3h1.497c.292.918.693 1.723 1.177 2.365A6.527 6.527 0 012.021 11zM7 13.936C5.972 13.661 5.087 12.557 4.55 11H7v2.936zM7 10H4.269a11.176 11.176 0 01-.259-2H7v2zm0-3H4.01c.029-.704.118-1.377.259-2H7v2zm0-3H4.55C5.087 2.443 5.972 1.339 7 1.065V4zm5.979 0h-1.496c-.293-.918-.693-1.723-1.178-2.365A6.54 6.54 0 0112.979 4zM8 1.065C9.027 1.339 9.913 2.443 10.45 4H8V1.065zM8 5h2.73c.142.623.229 1.296.26 2H8V5zm0 3h2.99a11.085 11.085 0 01-.26 2H8V8zm0 5.936V11h2.45c-.537 1.557-1.423 2.661-2.45 2.936zm2.305-.571c.483-.643.885-1.447 1.178-2.365h1.496a6.533 6.533 0 01-2.674 2.365zM13.502 10h-1.758c.134-.632.219-1.303.246-2h1.99a6.415 6.415 0 01-.478 2zM11.99 7a11.876 11.876 0 00-.246-2h1.758c.26.623.426 1.296.479 2H11.99z"}})])
          )
        }
      }
    